import tubiao from "../../static/pic/图表.svg"
import {Action} from "../../util/interfaceData"
import loadingImg from "../../static/pic/页面加载.gif"
import error from "../../static/pic/识别失败.svg"
import {isProduction} from "../../function/checkProduct"
const initialState = {
    recognitionArea: [],
    errorField: [],
    table: [],
    normalTableJson: [],
    jsonData: {},
    markdownName: "",
    errorMessage: "",
    showPic: tubiao,
    showTip: "请上传图片",
    pageLabel: "result", // result md json
}

export function modelTestReducer(state = initialState, action: Action) {
    // isProduction ? console.log("...state") : null
    // isProduction ? console.log(action.payload) : null
    // isProduction ? console.log("_______________________________") : null

    switch (action.type) {
        case "modelTestInit":
            return {
                ...initialState,
            }
        case "initData":
            return {
                ...state,
                ...action.payload,
            }
        case "setPageLabel":
            return {
                ...state,
                pageLabel: action.payload,
            }
        case "setJson":
            return {
                ...state,
                json: action.payload,
            }
        case "loading":
            return {
                ...initialState,
                showPic: loadingImg,
                showTip: "识别中......",
            }
        case "stopLoading":
            return {
                ...initialState,
                showPic: error,
                showTip: "上传失败，请上传格式正确的图片",
            }
        case "modelTestUpdate":
            return {
                ...state,
                ...action.payload,
            }
        case "error":
            return {
                ...initialState,
                showPic: error,
                showTip: "识别失败，请重新上传",
            }
        default:
            return state
    }
}
